var counter = 0; 

$('.note').each(function() {
    counter ++;
    var notes = $(this).data('note');
    $( ".notes-holder" ).append("<p>" + counter + ". " + notes + "</p>");
});


